module.exports = __webpack_public_path__ + "img/wallet.7d69d214.svg";